import Callout from "../../callout/Callout"
import Cardsimple from "../../cards/Cardsimple"

const CriteriosReposicion = ({data}) => {
    const Equipment = data
    return (
        <Cardsimple
            header={<h5 className="text-sm text-center my-0">🔄 Criterios para reposición</h5>}
            style={`card card-info bg-transparent border-0 text-xs`} 
            condensed={true}
        >
            {
                (Equipment.denominacion) && (
                    <div className="p-1">
                        <Callout
                            titulo={(Equipment.vidaUtilPorcentaje === "100") ? "Ha superado su tiempo de vida útil" : "No ha superado su tiempo de vida útil"}
                            estado={(Equipment.vidaUtilPorcentaje === "100") ? "success" : "secondary"}
                        >
                            <dl className="row">
                                <dt className="col-sm-4">Vida útil:</dt>
                                <dd className="col-sm-8">{Equipment.vidaUtil.toLowerCase()} años.</dd>
                                <dt className="col-sm-4">Antigüedad:</dt>
                                <dd className="col-sm-8">{Equipment.antiguedadMensaje.toLowerCase()}</dd>
                            </dl>
                        </Callout>

                        <Callout
                            titulo={(Equipment.costo_total > Equipment.costo_adq) ? "El costo acumulado de mantenimiento supera al costo de adquisición" : "El costo acumulado de mantenimiento no supera al costo de adquisición"}
                            estado={(Equipment.costo_total > Equipment.costo_adq) ? "success" : "secondary"}
                        >
                            <dl className="row">
                                <dt className="col-sm-4">Costo acumulado:</dt>
                                <dd className="col-sm-8">S/.{(new Intl.NumberFormat().format(Equipment.costo_total))}</dd>
                                <dt className="col-sm-4">Costo de Adquisición:</dt>
                                <dd className="col-sm-8">S/.{(new Intl.NumberFormat().format(Equipment.costo_adq))}</dd>
                            </dl>
                            <table className="table table-sm">
                                <tbody>
                                    <tr>
                                        <th colSpan={3} className="text-center">
                                            Detalle del costo acumulado
                                        </th>
                                    </tr>
                                    <tr>
                                        <td> Mano de Obra Sismac</td>
                                        <td>S/.</td>
                                        <td>{Equipment.costo_mano_sis}</td>
                                    </tr>
                                    <tr>
                                        <td>Repuestos Sismac</td>
                                        <td>S/.</td>
                                        <td>{Equipment.costo_rep_sis}</td>
                                    </tr>
                                    <tr>
                                        <td>Mano de Obra Pcoman</td>
                                        <td>S/.</td>
                                        <td>{Equipment.costo_mano_pco}</td>
                                    </tr>
                                    <tr>
                                        <td>Repuestos Pcoman</td>
                                        <td>S/.</td>
                                        <td>{Equipment.costo_rep_pco}</td>
                                    </tr>
                                    <tr>
                                        <th className="text-right">TOTAL </th>
                                        <td>S/.</td>
                                        <th>{(new Intl.NumberFormat().format(Equipment.costo_total))}</th>
                                    </tr>
                                </tbody>
                            </table>
                        </Callout>
                        <Callout
                            titulo={(Equipment.tasa_equipo > Equipment.tasa_familia) ? "La tasa de fallas del equipo es superior al promedio de fallas de la familia " : "La tasa de fallas del equipo es inferior al promedio de fallas de la familia"}
                            estado={(Equipment.tasa_equipo > Equipment.tasa_familia) ? "success" : "secondary"}
                        >
                            <dl className="row">
                                <dt className="col-sm-4">Tasa de fallas del equipo:</dt>
                                <dd className="col-sm-8">{(new Intl.NumberFormat().format(Equipment.tasa_equipo * 100))}%</dd>
                                <dt className="col-sm-4">Tasa de fallas de la familia:</dt>
                                <dd className="col-sm-8">{(new Intl.NumberFormat().format(Equipment.tasa_familia * 100))}%</dd>
                            </dl>
                        </Callout>
                        <Callout
                            titulo={"El equipo es obsoleto tecnológicamente ?"}
                            estado={"gray"}
                        >
                        </Callout>
                        <Callout
                            titulo={"El equipo tiene discontinuidad de repuestos o insumos ?"}
                            estado={"gray"}
                        >
                        </Callout>
                    </div>
                )
            }

        </Cardsimple>
    )
}
export default CriteriosReposicion